export const BADGE_TRAITEMENT = {
    EN_ATTENTE: 'en-attente',
    RECU: 'reçu',
    ABANDONNE: 'abandonné',
    ACCEPTE: 'accepté',
    REFUSE: 'refusé',
    REJETE: 'rejeté',
    TRAITE: 'traité',
    NON_TRAITE: 'non-traité',
};
